import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { call, select, spawn, put } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { runSaga } from 'store/sagaMiddleware'
import { action as apiAction } from 'api/Api'
import { calculatePositions } from 'utils/redux'
import sortedLayoutsSelector from '../selectors/sortedLayouts'
import {
  addLayout as addLayoutToView
} from '../redux/view'
import {
  add as addLayout,
  setPosition as setLayoutPosition
} from '../redux/layouts'
import taskStatus from 'store/sagas/taskStatus'
import {
  remove as removeToast
} from 'store/redux/toasts'

export default function * requestAddLayout (action) {
  const { template, name, position, isTemplate, addToMyHomeLayout } = action.payload

  const tempId = `temp-${new Date().getTime()}`

  const state = yield select()

  const layouts = sortedLayoutsSelector(state)

  const positions = calculatePositions({
    array: layouts,
    position
  })

  let optimisticAction

  if (addToMyHomeLayout) {
    optimisticAction = yield optimisticPut([
      addLayout({
        id: tempId,
        name: name,
        position,
        isBusy: true
      }),
      addLayoutToView({
        id: tempId
      }),
      ...positions.map(({ id, position }) =>
        setLayoutPosition({
          id,
          position
        })
      )
    ])
  }

  try {
    const { Id, TaskId } = yield call(apiAction, 'AddHomeLayout', {
      template,
      name,
      position,
      isTemplate,
      addToMyHomeLayout,
    })

    if (TaskId) {
      yield spawn(taskStatus, {
        taskId: TaskId,
        progressMessage: (
          <FormattedMessage
            id='DESK_ADD_PROGRESS_RUNNING'
            values={{
              name: <b>{name}</b>
            }}
          />
        ),
        completedMessage: (
          <FormattedMessage
            id='DESK_ADD_PROGRESS_COMPLETED'
            values={{
              name: (
                <Link
                  to={`/home/${Id}`}
                  onClick={() => runSaga(function * () {
                    yield put(removeToast({
                      id: `task-${TaskId}`,
                    }))
                  })}
                >
                  {name}
                </Link>
              )
            }}
          />
        ),
        failMessage: (
          <FormattedMessage
            id='DESK_ADD_PROGRESS_FAILED'
            values={{
              name: <b>{name}</b>
            }}
          />
        ),
      })
    }
  } finally {
    if (optimisticAction) {
      yield optimisticAction.revert()
    }
  }
}
